<template>
  <article class="table--scroll">
    <header>
      <router-link :to="link"
        ><h1>{{ payload.attributes.title }}</h1></router-link
      >
      <router-link class="no-hover" :to="sectionLink(payload.attributes.section)">
        <span class="pill">{{
          payload.attributes.section || (!payload.attributes.slug ? 'news' : payload.attributes.slug)
        }}</span>
      </router-link>
      <span v-if="payload.attributes.author">
        {{ $t('ui.content.by_author') }}
        <address>
          <span>{{ payload.attributes.author }}</span>
        </address>
      </span>
      <span v-if="payload.attributes.date">
        {{ $t('ui.content.on_date') }}
        <time :datetime="new Date(payload.attributes.date)" pubdate title="">{{ payload.attributes.date | Date }}</time>
      </span>
    </header>
    <MarkdownText :md="payload.attributes.__content" />
    <p>
      <router-link class="no-hover" :to="'/tag/' + tag" v-for="tag of payload.attributes.tags || []" :key="tag">
        <span class="pill pill--rounded">{{ tag }}</span>
      </router-link>
    </p>
  </article>
</template>

<script>
import MarkdownText from '../shared/MarkdownText.vue';
import { locale } from '../locale';
import { getRouteFromPost } from '../route.util';

export default {
  name: 'StandardArticle',
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  data: () => ({ locale }),
  computed: {
    link() {
      return getRouteFromPost(this.payload);
    },
  },
  methods: {
    sectionLink(section) {
      return getRouteFromPost({ name: '', attributes: { section, language: this.$i18n.locale, title: '' } }).replace(
        /\/null$/i,
        '',
      );
    },
  },
  components: {
    MarkdownText,
  },
};
</script>

<style>
.pill {
  background-color: rgba(255, 29, 94, 0.5);
  font-size: small;
  font-weight: bold;
  border-radius: 3px;
  padding: 0.2rem 0.5rem;
  color: white;
  margin: 0 0.1rem;
}

.pill--rounded {
  background-color: var(--coral-o-cc);
  border-radius: 15px;
}

.pill:hover {
  /*background-color: #ff1d5e;*/
  background-color: rgba(255, 29, 94, 0.7);
}

.pill--rounded:hover {
  background-color: var(--coral);
}

a:hover {
  text-decoration-color: black;
}

.no-hover:hover {
  text-decoration: none;
}
</style>
